// src/hooks/useKeyboardVisibility.ts
import { useState, useEffect } from 'react';

const useKeyboardVisibility = () => {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  useEffect(() => {
    const handleFocus = (event: FocusEvent) => {
      const target = event.target as HTMLElement;
      const isInputField = target.tagName === 'INPUT';
      const isTextArea = target.tagName === 'TEXTAREA';
      const isTipTapEditor = target.className === 'tiptap ProseMirror';

      if (isInputField || isTextArea || isTipTapEditor) {
        setIsKeyboardVisible(true);
      }
    };

    const handleBlur = () => {
      setIsKeyboardVisible(false);
    };

    // Add event listeners for focus and blur
    document.addEventListener('focus', handleFocus, true);
    document.addEventListener('blur', handleBlur, true);

    // Cleanup event listeners
    return () => {
      document.removeEventListener('focus', handleFocus, true);
      document.removeEventListener('blur', handleBlur, true);
    };
  }, []);

  return isKeyboardVisible;
};

export default useKeyboardVisibility;
